export default "<button\n  class=\"zoom-button\"\n  [ngClass]=\"{'zoom-button--theme-color': useThemeColor}\"\n></button>\n"